<template>
    <div class="box-vertical w100" style="height: 100%;position:absolute">
        <div class="nav bg-biru pl20 pr20 pt10 pb10 w100">
            <div class="box-horizontal">
                <div class="" @click="met.back()">
                    <img src="@/assets/back.png" alt="" style="height:30px">
                </div>
                <div class="flex-1 f13 text-center white">
                    Lanjutkan Pembayaran
                </div>
                <div class=""></div>
            </div>
        </div>
        <div class="wrapper m0 flex-1 w100 box-vertical">
            <div class="body flex-1 box-vertical">
                <p class="text-center" style="font-size: 16pt;">Sedang Membuka Halaman Bayar...</p>
            </div>
        </div>
    </div>
</template>

<script>
import myGlobal from '@/MyGlobal'
import { reactive } from '@vue/composition-api'
import store from '@/store/index'
import inter from '@/Interface'
import router from '@/router'
import Loading from '@/global/Loading' 

export default {
    setup() {
        const get = {
            data: reactive({
                this: '',
                url: null
            }),
            list() {
                var datax = {
                    token: 'TangTung ' //+sessionStorage.getItem('Token')
                };
            
                var apiUrl = inter.KategoriList();

                myGlobal.call(datax,apiUrl).then(x => {
                    //console.log(JSON.stringify(x));
                    //data.loading = false;
                    if (x.status == true) {
                        mainData.data = x.data;
                        //theGet.data.Total = x.pesan;
                    } else {
                        
                    }
                })
            }
        }
        const met = {
            back() {
                window.history.back();
            },
            halamanBayar() {
                location.href = get.data.url;
            }
        }

        const redirectx = {
            checkApp() {
                myGlobal.checkApp();
            },
            now() {
                location.href="#/";
            }
        }

        return {
            met,
            get,
            redirectx
        }

    },
    mounted () {        
        this.redirectx.checkApp();

        let params = this.$route.params;
        let data = params.qr;

        //console.log(JSON.stringify(params));

        this.get.data.url = data.actions.mobile_web_checkout_url;

        var t = this;
        setTimeout(function(){
            console.log(t.get.data.url);
            t.met.halamanBayar();
        }, 3000);
    }
}
</script>


// WEBPACK FOOTER //
// src/components/User/Wallet/main.vue